import {
  ISignificanceQueryFieldsFragment,
  MetricTypeKey,
} from '../../apollo/graphqlSchema';
import { ISignificanceBuilderFields } from '../../../redux/slices/oldBuilder/significance/types';
import { UnreachableCaseError } from 'ts-essentials';

const parseMetricFields = (
  metric: ISignificanceQueryFieldsFragment['metric'],
): ISignificanceBuilderFields['metric'] => {
  switch (metric.__typename) {
    case 'MeasureMetric': {
      const { measure } = metric;
      return {
        type: MetricTypeKey.Measure,
        measure,
      };
    }
    case 'QueryMetric': {
      const { expression, measure } = metric;
      return {
        type: MetricTypeKey.Query,
        analysisId: expression.id,
        measureId: measure.id,
        aliasReplacements: expression.pref.aliasReplacements,
      };
    }
    case 'FunnelMetric': {
      const { convertedOnStep, funnel, ttcMetric } = metric;
      return {
        type: MetricTypeKey.Funnel,
        analysisId: funnel.id,
        steps: funnel.query.steps,
        convertedOnStep,
        aliasReplacements: funnel.pref.aliasReplacements,
        mode: funnel.query.mode?.key ?? null,
        modeSlices: funnel.query.modeSlices,
        ttcMetric,
      };
    }
    case 'RetentionMetric': {
      const { retention } = metric;
      return {
        type: MetricTypeKey.Retention,
        analysisId: retention.id,
      };
    }
    default: {
      throw new UnreachableCaseError(metric);
    }
  }
};

export default parseMetricFields;
